<template>
    <div>
        <!--nav-->
        <div class="nav clearfloat">
            <ul class="container">
                <li :class="getLink('/welcome')"><a href="/welcome">首页</a></li>
                <li :class="getLink('/mall/mall')"><a href="/mall/mall">现货商城</a></li>
                <!--<li :class="getLink('/mall/index?building=true')"><a href="/mall/index?building=true">建筑木材</a></li>-->
                <li :class="getLink('/company/company_list')"><a href="/company/company_list">经销商列表</a></li>
                <li :class="getLink('/supplier/futures')"><a href="/supplier/futures">全球木材采购中心</a></li>
                <li :class="getLink('/supplier/supply')"><a href="/supplier/supply">供应资源</a></li>
                <!--<li :class="getLink('/news/news')"><a href="/news/news">行业资讯</a></li>-->
                <li :class="getLink('/support/trust')"><a href="/support/trust">委托找货</a></li>
                <li class="down">供应链
                    <ul>
                        <!--<li :class="getLink('/support/trust')"><a href="/support/trust">找货</a></li>-->
                        <li :class="getLink('/support/finance')"><a href="/support/finance">金融</a></li>
                        <li :class="getLink('/support/logistics')"><a href="/support/logistics">物流</a></li>
                        <li :class="getLink('/support/warehouse')"><a href="/support/warehouse">仓库</a></li>
                    </ul>
                </li>
                <li class="right padding0">
                    咨询热线：
                    <span class="green">400-723-0868</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            getLink(path) {
                let c = this.$route.fullPath === path ? 'current' : ''
                if (this.$route.fullPath === '/' && path === '/welcome') {
                    c = 'current'
                }

                return c
            }
        }
    }
</script>



// WEBPACK FOOTER //
// nav.vue?9fa5bcae